export default __webpack_public_path__ + "static/media/mathspic6.0e67e9e5.jpeg";